import {
  type SecurityTokens,
  StorageKeys,
  localStorageService,
} from '@/services/storage';

export const setSecurityTokens = (newToken: SecurityTokens) => {
  localStorageService.setItem<SecurityTokens>(StorageKeys.securityTokens, {
    jwtToken: newToken.jwtToken!,
    refreshToken: newToken.refreshToken!,
  });
};

export const getSecurityTokens = () => {
  return localStorageService.getItem<SecurityTokens>(
    StorageKeys.securityTokens
  );
};

export const removeSecurityTokens = () => {
  localStorageService.removeItem(StorageKeys.securityTokens);
};
